export const getActivityTitle = (activity: string) => {
  switch (activity) {
    case 'equipment-check-v2':
      return 'Сканирование ХО';
    default: return '';
  }
};